import { render, staticRenderFns } from "./PolicyGeneral.vue?vue&type=template&id=29c0c612&"
import script from "./PolicyGeneral.vue?vue&type=script&lang=js&"
export * from "./PolicyGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports